// https://imagesloaded.desandro.com/
const imagesLoaded = require('imagesloaded');
const $ = require('jquery');

imagesLoaded.makeJQueryPlugin($);

const imagesLoadedHandler = function($container) {
  const container = $container || $('@body');
  const $window = $(window);
  const $images = container.find($('img'));
  const $imagesPresent = () => $images.length > 0;

  if ($imagesPresent()) {
    container.imagesLoaded()
      .always(() => {
        $window.trigger('resize');
      })
      .progress((imgLoad, image) => {
        const $item = $(image.img).parent();
        $item.removeClass('image_loading');
        if (!image.isLoaded) {
          $item.addClass('image_broken');
        }
      });
  }
};

export default imagesLoadedHandler;
